<div class="exportar-cont">
  <p class="p-g">Exportar a</p>
  @for(exportar of metexportar; track exportar){
  <img
    [src]="exportar.icon"
    alt=""
    (click)="exportarArchivo(exportar.name)"
    style="cursor: pointer"
  />
  }
</div>
